import React from 'react'
import praleevid from '../../assets/videos/pralee.mp4'
export default function PraleeIntroVideo() {
    return (
        <div className='flex items-center justify-center md:mx-24 shadow-2xl md:border-4'>
            <video src={praleevid} autoPlay muted loop className='h-3/4'/>
        </div>
    )
}
